/* eslint-disable */
/* tslint:disable */
/*
 * ---------------------------------------------------------------
 * ## THIS FILE WAS GENERATED VIA SWAGGER-TYPESCRIPT-API        ##
 * ##                                                           ##
 * ## AUTHOR: acacode                                           ##
 * ## SOURCE: https://github.com/acacode/swagger-typescript-api ##
 * ---------------------------------------------------------------
 */

import { DeleteCommissionRateRequest } from './data-contracts';
import { ContentType, HttpClient, RequestParams } from './http-client';

export class CommissionRateMassDeletes<
  SecurityDataType = unknown,
> extends HttpClient<SecurityDataType> {
  /**
   * No description
   *
   * @name DeleteCommissionRate
   * @request POST:/commissionRate-mass-deletes
   * @secure
   */
  deleteCommissionRate = (data: DeleteCommissionRateRequest, params: RequestParams = {}) =>
    this.request<void, any>({
      path: `/commissionRate-mass-deletes`,
      method: 'POST',
      body: data,
      secure: true,
      type: ContentType.Json,
      ...params,
    });
  /**
   * No description
   *
   * @name OptionsCommissionRateMassDeletes
   * @request OPTIONS:/commissionRate-mass-deletes
   */
  optionsCommissionRateMassDeletes = (params: RequestParams = {}) =>
    this.request<void, any>({
      path: `/commissionRate-mass-deletes`,
      method: 'OPTIONS',
      ...params,
    });
}
